import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';

import { componentsSize } from 'constants/components';
import { CrossIcon as CloseIcon } from 'assets/icons';

const styles = {
  iconButton: ({ palette, breakpoints }, size) => ({
    width: size === componentsSize.large ? 40 : 24,
    height: size === componentsSize.large ? 40 : 24,
    padding: 'unset !important',
    borderRadius: 50,
    border: `2px solid ${palette.primary.main}`,
    background: palette.common.white,
    position: 'absolute',
    top: 16,
    right: 16,
    '&:hover': {
      background: palette.common.white,
    },
    [breakpoints.up('md')]: {
      width: size === componentsSize.large ? 48 : 40,
      height: size === componentsSize.large ? 48 : 40,
    },
  }),
  icon: ({ palette, breakpoints }, size) => ({
    color: palette.primary.main,
    width: 12,
    height: 12,
    [breakpoints.up('md')]: {
      width: size === componentsSize.large ? 20 : 12,
      height: size === componentsSize.large ? 20 : 12,
    },
  }),
};

const ButtonCloseDialog = ({ onClick = () => {}, customStyles = null, size = componentsSize.small, ...props }) => {
  return (
    <IconButton
      {...props}
      onClick={onClick}
      sx={(theme) => ({
        ...styles.iconButton(theme, size),
        ...customStyles,
      })}
    >
      <Box component={CloseIcon} sx={(theme) => styles.icon(theme, size)} />
    </IconButton>
  );
};

ButtonCloseDialog.propTypes = {
  onClick: PropTypes.func,
  customStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  size: PropTypes.oneOf(Object.values(componentsSize)),
};
export default ButtonCloseDialog;
